module.exports = __webpack_public_path__ + "static/media/08-1.56e6c9e0.png";